import React from 'react';

import { ColorPalette } from 'theme/colors';

import { ReactComponent as CheckCircle } from 'assets/images/check-circle.svg';
import { ReactComponent as Clock } from 'assets/images/clock.svg';
import { ReactComponent as ExclamationCircle } from 'assets/images/exclamation-circle.svg';
import { ReactComponent as XCircle } from 'assets/images/x-circle.svg';
import { TagsIcon, TagsColor } from 'utils/statusTag';

import { Container } from './styles';

interface Props {
  icon?: TagsIcon;
  color: TagsColor;
  children: React.ReactNode;
}

const COLOR: Record<TagsColor, string> = {
  red: ColorPalette.HEX.RedRYB,
  yellow: '#ffa500',
  green: ColorPalette.HEX.GreenPantone,
  gray: ColorPalette.HEX.Manatee,
};

const ICON: Record<TagsIcon, React.FunctionComponent> = {
  clock: Clock,
  x: XCircle,
  check: CheckCircle,
  exclamation: ExclamationCircle,
};

const Tags = ({ icon, color, children }: Props) => {
  const Icon = ICON[icon || 'x'];

  return (
    <Container $color={COLOR[color]}>
      {icon && <Icon />}
      {children}
    </Container>
  );
};

export default Tags;
